<template>
  <v-dialog v-model="showDialog" persistent max-width="900px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formCliente" :v-model="true" lazy-validation>
            <v-layout wrap class="container">
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Sucursal"
                  v-model="nombreSucursal"
                  placeholder="Sucursal del cliente"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Nombre completo"
                  v-model="cliente.nombreCompletoCliente"
                  placeholder="Nombre completo del cliente"
                  :rules="[
                    () =>
                      !!cliente.nombreCompletoCliente ||
                      'El campo es requerido',
                  ]"
                  required
                  @input="cliente.nombreCompletoCliente.toUpperCase()"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Domicilio"
                  v-model="cliente.domicilio"
                  placeholder="Donde radica el cliente"
                  hint="Lugar de ubicación"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md8>
                <v-text-field
                  label="Colonia"
                  v-model="cliente.colonia"
                  placeholder="Colonia donde radica el cliente"
                  hint="Lugar de ubicación"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-text-field
                  label="Código postal"
                  v-model="cliente.codigoPostal"
                  :rules="[(v) => v.length <= 5 || 'Máximo 5 dígitos']"
                  :counter="5"
                  type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  v-model="cliente.paisId"
                  :items="paises"
                  item-text="nombre"
                  item-value="paisId"
                  label="País"
                  placeholder="País"
                  persistent-hint
                  single-line
                ></v-select>
              </v-flex>

              <v-flex xs6>
                <v-select
                  v-model="cliente.entidadId"
                  :items="entidades"
                  item-text="nombreEntidad"
                  item-value="entidadId"
                  label="Entidad"
                  placeholder="Entidad"
                  single-line
                  @input="getMunicipios"
                  :rules="[
                    () => !!cliente.entidadId || 'El campo es requerido',
                  ]"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs6>
                <v-combobox
                  v-model="cliente.municipio"
                  :items="municipios"
                  item-text="nombreMunicipio"
                  :loading="loadingMunicipios"
                  item-value="municipioId"
                  label="Municipio"
                  placeholder="Municipio"
                  single-line
                  :rules="[
                    () => !!cliente.municipioId || 'El campo es requerido',
                  ]"
                  required
                  @change="setMunicipio"
                ></v-combobox>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field
                  label="Teléfono"
                  v-model="cliente.telefonoParticular"
                  placeholder="Teléfono particular"
                  hint="Teléfono particular"
                  mask="(###) ### - ####"
                  return-masked-value
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field
                  label="Celular"
                  v-model="cliente.telefonoCelular"
                  placeholder="Teléfono celular"
                  hint="Teléfono celular"
                  mask="(###) ### - ####"
                  return-masked-value
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Correo contacto"
                  v-model="cliente.correoContacto"
                  placeholder="Correo electrónico"
                  hint="Correo electrónico"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-text-field
                  label="% Descuento del cliente"
                  hint="% de descuento que se le hará al cliente"
                  v-model="cliente.descuento"
                  prefix="%"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveCliente"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >{{ mensajeCliente }}</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
//Services;
import clienteService from "@/services/clienteService";
import catalogoService from "@/services/catalogoServices";

export default {
  props: {
    cliente: {
      type: Object,
    },
    sucursal: {
      type: Object,
      required: true,
    },
  },
  watch: {
    sucursal: function (n) {
      this.cliente.sucursalId = n.sucursalId;
      this.nombreSucursal = n.nombreSucursal;
    },
    cliente: function (n) {
      if (n.clienteId !== 0) {
        this.getMunicipios(n.entidadId);
      }
    },
  },
  data() {
    return {
      showDialog: false,
      mensajeCliente: "Cliente guardado con éxito",
      paises: [{ paisId: 146, nombre: "MÉXICO" }],
      loadingMunicipios: false,
      entidades: [],
      municipios: [],
      nombreSucursal: "",
    };
  },
  created() {},
  methods: {
    openDialog() {
      this.getEntidades();
      this.showDialog = true;
    },
    setMunicipio(municipio) {
      this.cliente.municipioId = municipio.municipioId;
    },
    getEntidades() {
      let self = this;

      catalogoService
        .getEntidades()
        .then((result) => {
          self.entidades = result;
          self.getMunicipios(11);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getMunicipios(entidadId) {
      let self = this;

      self.loadingMunicipios = true;

      if (typeof entidadId === "undefined") {
        return;
      }
      catalogoService
        .getMunicipios(entidadId)
        .then((result) => {
          self.municipios = result;
          if (self.cliente.clienteId === 0) {
            console.log("cliente nuevo");
            let municipio = self.municipios.find((m) => m.municipioId == 340);
            self.cliente.municipio = municipio;
            self.cliente.municipioId = 340;
          }
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingMunicipios = false;
        });
    },
    saveCliente() {
      let self = this;

      if (self.$refs.formCliente.validate()) {
        self.operationStart();

        if (self.cliente.clienteId === 0) {
          self.addCliente();
        } else {
          self.updateCliente();
        }
      }
    },
    addCliente() {
      let self = this;

      clienteService
        .add(self.cliente)
        .then((result) => {
          self.mensajeCliente = "Cliente guardado con éxito";
          self.operationSuccess();
          self.$store.state.successMessage = "Cliente guardado con éxito";

          //Enviar tipo producto al componente padre
          self.$emit("onClienteAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            //self.resetForm();
          }, 1500);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateCliente() {
      let self = this;

      clienteService
        .update(self.cliente)
        .then((result) => {
          self.operationSuccess();
          self.$store.state.successMessage = "Cliente actualizado con éxito";
          //Enviar tipo producto al componente padre
          self.$emit("onClienteUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            //self.resetForm();
          }, 1500);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formCliente.resetValidation();
      self.cliente.clienteId = 0;
      self.cliente.nombreCompletoCliente = "";
      self.cliente.domicilio = null;
      self.cliente.colonia = null;
      self.cliente.codigoPostal = "";
      self.cliente.paisId = 146;
      self.cliente.entidadId = 11;
      self.cliente.municipioId = 340;
      self.cliente.telefonoParticular = null;
      self.cliente.telefonoCelular = null;
      self.cliente.correoContacto = null;
      self.cliente.descuento = 0;
      self.cliente.municipio = {
        municipioId: 0,
        nombreMunicipio: "",
      };
    },
  },
};
</script>
